import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { Translation } from 'react-i18next'

class NewSalaryInfoComponent extends React.Component {
  render() {
    return <NewSalaryInfo {...this.props} />
  }
}

const styles = (theme) => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    '&::-webkit-scrollbar': {
      width: '12px !important',
      webkitOverflowScrolling: 'auto !important'
    },

    '&::-webkit-scrollbar-track': {
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.3) !important',
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important'
    },

    '&::-webkit-scrollbar-thumb': {
      webkitBorderRadius: '10px !important',
      borderRadius: '10px !important',
      background: '#41617D !important',
      webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.5) !important'
    },

    '&::-webkit-scrollbar-thumb:window-inactive': {
      background: '#41617D !important'
    }
  },

  tablecell: {
    fontWeight: 'bold',
    fontSize: '13px',
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px'
    },
    [theme.breakpoints.down('400')]: {
      padding: '0 5px'
    }
  },
  tablecell1: {
    fontWeight: 'normal',
    fontSize: '13px',
    color: 'black',
    [theme.breakpoints.down('xs')]: {
      padding: '0 20px'
    },
    [theme.breakpoints.down('400')]: {
      padding: '0 5px'
    }
  }
})

const START_OF_SALARY_KHO_2023_42_IMPLEMENTATION = new Date(
  2023,
  5,
  29,
  13,
  15,
  0,
  0
)
const NewSalaryInfo = ({ newSalaryInfo, classes }) => {
  // Incase the salary had invoice items + allowances || expense where the service cost
  // exceeds the invoice items vat 0 amount. If not display regular service cost
  let invoiceItemsServiceCost = newSalaryInfo.service_cost
  if (
    newSalaryInfo.service_cost > newSalaryInfo.deductions_sum &&
    newSalaryInfo.gross_salary === 0
  ) {
    invoiceItemsServiceCost =
      newSalaryInfo.service_cost - newSalaryInfo.deductions_sum
  }

  // Salary Change: KHO 2023:42 implemented
  return new Date(newSalaryInfo.created) <
    START_OF_SALARY_KHO_2023_42_IMPLEMENTATION ? (
    <Translation>
      {(t) => {
        return (
          <div
            className="dashboard-content-header"
            id="salary-info-scroll-section"
          >
            <div className="col-md-6 col-sm-6">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="panel-title">{t('salary.div')}</h3>
                </div>
                <div className={classes.root}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '70%' }}
                        >
                          <div className="dashboard-salary-header">
                            {t('salary.table')}
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '30%' }}
                        />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table1')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.sumWithTax)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <hr />
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '70%' }}
                        >
                          <div className="dashboard-salary-header">
                            {t('salary.table2')}
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '30%' }}
                        />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table3')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.sumWithoutTax)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table4')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.reimbursment_cost)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table5')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.expenses_cost)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          <b>{t('salary.table6')}</b>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.gross_salary)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table7')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.tax_cost)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          <b>{t('salary.table8')}</b>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.net_salary)}
                        </TableCell>
                      </TableRow>
                      {
                        newSalaryInfo.normal_govpay_sum > 0 ||
                        newSalaryInfo.brutto_sum_govpay > 0
                          ? (
                            <TableRow style={{ background: '#ebf9fa' }}>
                              <TableCell
                                className={classes.tablecell1}
                                style={{ width: '70%' }}
                              >
                                {t('newSalarySummary.table17')}
                              </TableCell>
                              <TableCell
                                className={classes.tablecell1}
                                style={{ width: '30%' }}
                              >
                                {new Intl.NumberFormat('fi-FI', {
                                  style: 'currency',
                                  currency: 'EUR'
                                }).format(
                                  newSalaryInfo.normal_govpay_sum > 0 
                                    ? newSalaryInfo.normal_govpay_sum
                                    : newSalaryInfo.brutto_sum_govpay
                                )}
                              </TableCell>
                            </TableRow>
                          ) 
                          : null
                      }
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table9')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.yel_cost)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table10')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.service_cost)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table11')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.social_contribution)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          <b>{t('salary.table13')}</b>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.deductions_sum)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <hr />
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '70%' }}
                        >
                          <div className="dashboard-salary-header">
                            {t('salary.table14')}
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '30%' }}
                        >
                          <div className="dashboard-salary-header">
                            {new Intl.NumberFormat('fi-FI', {
                              style: 'currency',
                              currency: 'EUR'
                            }).format(newSalaryInfo.take_home_pay)}
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  ) : (
    <Translation>
      {(t) => {
        return (
          <div
            className="dashboard-content-header"
            id="salary-info-scroll-section"
          >
            <div className="col-md-6 col-sm-6">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h3 className="panel-title">{t('salary.div')}</h3>
                </div>
                <div className={classes.root}>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '70%' }}
                        >
                          <div className="dashboard-salary-header">
                            {t('salary.table')}
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '30%' }}
                        />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table1')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.sumWithTax)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <hr />
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '70%' }}
                        >
                          <div className="dashboard-salary-header">
                            {t('salary.table2')}
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '30%' }}
                        />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table3')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.sumWithoutTax)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table10')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(invoiceItemsServiceCost)}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table11')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.social_contribution)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          <b>{t('salary.table6')}</b>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.gross_salary)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table7')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.tax_cost)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          <b>{t('salary.table8')}</b>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.net_salary)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table4')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.reimbursment_cost)}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ background: '#ebf9fa' }}>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table5')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.expenses_cost)}
                        </TableCell>
                      </TableRow>
                      {
                        newSalaryInfo.normal_govpay_sum > 0 ||
                        newSalaryInfo.brutto_sum_govpay > 0
                          ? (
                            <TableRow style={{ background: '#ebf9fa' }}>
                              <TableCell
                                className={classes.tablecell1}
                                style={{ width: '70%' }}
                              >
                                {t('newSalarySummary.table17')}
                              </TableCell>
                              <TableCell
                                className={classes.tablecell1}
                                style={{ width: '30%' }}
                              >
                                {new Intl.NumberFormat('fi-FI', {
                                  style: 'currency',
                                  currency: 'EUR'
                                }).format(
                                  newSalaryInfo.normal_govpay_sum > 0 
                                    ? newSalaryInfo.normal_govpay_sum
                                    : newSalaryInfo.brutto_sum_govpay
                                )}
                              </TableCell>
                            </TableRow>
                          ) 
                          : null
                      }

                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          {t('salary.table9')}
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.yel_cost)}
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '70%' }}
                        >
                          <b>{t('salary.table13')}</b>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell1}
                          style={{ width: '30%' }}
                        >
                          {new Intl.NumberFormat('fi-FI', {
                            style: 'currency',
                            currency: 'EUR'
                          }).format(newSalaryInfo.deductions_sum)}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                  <hr />
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '70%' }}
                        >
                          <div className="dashboard-salary-header">
                            {t('salary.table14')}
                          </div>
                        </TableCell>
                        <TableCell
                          className={classes.tablecell}
                          style={{ width: '30%' }}
                        >
                          <div className="dashboard-salary-header">
                            {new Intl.NumberFormat('fi-FI', {
                              style: 'currency',
                              currency: 'EUR'
                            }).format(newSalaryInfo.take_home_pay)}
                          </div>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        )
      }}
    </Translation>
  )
}

NewSalaryInfoComponent.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(NewSalaryInfoComponent)
